import React, { useState } from "react";
import { FaRupeeSign } from "react-icons/fa";
import QRCode from "qrcode";

const UserUpi = () => {
  const [upiID, setUpiID] = useState("");
  const [amount, setAmount] = useState("");
  const [upiLink, setUpiLink] = useState("");

  const generateUPILink = () => {
    if (upiID.includes("@")) {
      const url = `upi://pay?pa=${upiID}&pn=UPAYI&cu=INR${amount ? `&am=${amount}` : ""}`;
      setUpiLink(url);
      navigator.clipboard.writeText(url);
    } else {
      alert("Invalid UPI ID");
    }
  };

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-900 text-white p-6">
      <div className="bg-gray-800 p-8 rounded-xl shadow-lg w-full max-w-lg text-center">
        <h1 className="text-2xl font-bold mb-4">UPI Payment Link Generator</h1>
        <p className="text-gray-400 mb-6">Generate a shareable UPI payment link or QR code instantly.</p>

        <div className="mb-4">
          <label className="block text-left text-sm mb-2">Enter UPI ID</label>
          <input
            type="text"
            value={upiID}
            onChange={(e) => setUpiID(e.target.value)}
            className="w-full p-2 rounded bg-gray-700 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="example@upi"
          />
        </div>

        <div className="mb-4">
          <label className="block text-left text-sm mb-2">Enter Amount (Optional)</label>
          <div className="relative">
            <div className="absolute left-3 top-2">
              <FaRupeeSign className="text-gray-400" />
            </div>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full pl-8 p-2 rounded bg-gray-700 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter Amount"
            />
          </div>
        </div>

        <button
          onClick={generateUPILink}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition duration-300"
        >
          Generate Link
        </button>

        {upiLink && (
          <div className="mt-6 text-center">
            <h2 className="text-lg font-semibold mb-2">Scan to Pay</h2>
            <div className="bg-white p-4 rounded-lg inline-block">
              <QRCode value={upiLink} size={180} />
            </div>
            <p className="mt-2 text-gray-400 text-sm">UPI Link copied to clipboard</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserUpi;
